<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      floating
      app
      class="sidebar-drawer"
      :mini-variant-width="$vuetify.breakpoint.mdAndUp ? '4vw' : '12vw'"
      :mini-variant.sync="mini"
      :mini="mini"
      style="background-color: whitesmoke"
    >
      <div class="sidebar-shell">
        <div class="sidebar-main">
          <v-list class="transparent" nav>
            <v-list-item class="mt-2">
              <v-img
                contain
                height="7vh"
                :src="
                  mini
                    ? require('@/assets/images/logo_pitch.webp')
                    : require('@/assets/icons/connect_logo_bar.svg')
                "
              />
            </v-list-item>
          </v-list>
          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
            >
              <v-list-item-avatar size="40" rounded>
                <v-img
                  contain
                  height="2vh"
                  src="@/assets/icons/home.svg"
                ></v-img>
              </v-list-item-avatar>
              <router-link :to="`${module}/cockpit`">
                <v-list-item-title>Início</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-group class="sidebar-group">
              <template v-slot:activator>
                <v-list-item-avatar size="40" rounded>
                  <v-img
                    contain
                    height="2vh"
                    src="@/assets/icons/course.svg"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-title>Curso</v-list-item-title>
              </template>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-folder</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/curso`">
                  <v-list-item-title>Módulos</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item
                custom
                class="d-flex align-center justify-start"
                v-if="module === 'aluno'"
              >
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-file-outline</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/curso`">
                  <v-list-item-title>Certificados</v-list-item-title>
                </router-link>
              </v-list-item>
            </v-list-group>
          </v-list>

          <v-list
            v-if="!isSoloCustomer"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-group class="sidebar-group">
              <template v-slot:activator>
                <v-list-item-avatar size="40" rounded>
                  <v-img
                    contain
                    height="2vh"
                    src="@/assets/icons/document.svg"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-title>Turmas</v-list-item-title>
              </template>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon>mdi-google-classroom</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/turmas`">
                  <v-list-item-title>Minhas Turmas</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-book-variant</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/agenda`">
                  <v-list-item-title>Minhas Aulas</v-list-item-title>
                </router-link>
              </v-list-item>
            </v-list-group>
          </v-list>

          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-group class="sidebar-group">
              <template v-slot:activator>
                <v-list-item-avatar size="40" rounded>
                  <v-img
                    contain
                    height="2vh"
                    src="@/assets/icons/calendar.svg"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-title>Agenda</v-list-item-title>
              </template>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-calendar</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/agenda`">
                  <v-list-item-title>Eventos</v-list-item-title>
                </router-link>
              </v-list-item>
            </v-list-group>
          </v-list>

          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-group class="sidebar-group">
              <template v-slot:activator>
                <v-list-item-avatar size="40" rounded>
                  <v-img
                    contain
                    height="2vh"
                    src="@/assets/icons/wallet.svg"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-title>Financeiro</v-list-item-title>
              </template>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-credit-card</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/financeiro`">
                  <v-list-item-title>Pagamentos</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-hand-coin-outline</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/financeiro`">
                  <v-list-item-title>Pitch Coins</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon height="2vh">mdi-lightning-bolt-outline</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/financeiro`">
                  <v-list-item-title>Promoções</v-list-item-title>
                </router-link>
              </v-list-item>
            </v-list-group>
          </v-list>

          <v-divider class="ma-0 pa-0"></v-divider>

          <v-list class="transparent mt-2 fill-width" nav>
            <router-link :to="`${this.module}/notificacoes`" custom>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    class="mb-4 pb-5 px-0 pt-4 d-flex align-center"
                    style="max-height: 4vh !important"
                  >
                    <v-list-item-avatar rounded>
                      <v-badge
                        v-if="notificationsCount"
                        overlap
                        dense
                        :content="notificationsCount"
                        class="notification-badge"
                        :class="{
                          'notification-badge--active': notificationsCount > 0,
                        }"
                      >
                        <v-icon
                          style="background-color: transparent"
                          :class="{
                            'notification-bell--blinking':
                              notificationsCount > 0,
                          }"
                        >
                          mdi-bell-outline
                        </v-icon>
                      </v-badge>
                      <v-icon style="background-color: transparent" v-else>
                        mdi-bell-outline
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="d-flex align-center">
                      <v-list-item-title>Notificações</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span> Notificações </span>
              </v-tooltip>
            </router-link>
          </v-list>
        </div>

        <div class="sidebar-footer">
          <v-list class="transparent fill-width" nav>
            <router-link :to="`${this.module}/perfil`" custom>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    class="mb-4 pb-5 px-0 pt-4 d-flex align-center"
                    style="max-height: 4vh !important"
                  >
                    <v-list-item-avatar
                      size="40"
                      rounded
                      v-if="avatarUrl"
                      class="sidebar-profile-avatar"
                    >
                      <v-img
                        alt="avatar"
                        :src="avatarUrl"
                        cover
                        class="sidebar-profile-avatar__image"
                      ></v-img>
                    </v-list-item-avatar>
                    <v-list-item-avatar size="40" rounded v-else>
                      <v-avatar size="40" :color="avatarFallbackColor">
                        <strong class="white--text">
                          {{ customerInitials }}
                        </strong>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content class="d-flex align-center">
                      <v-list-item-title>Perfil</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span> Perfil </span>
              </v-tooltip>
            </router-link>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  v-bind="attrs"
                  v-on="on"
                  class="mb-4 pb-5 px-0 pt-4"
                  @click="logoff"
                  style="max-height: 4vh !important"
                >
                  <v-list-item-avatar size="40" rounded>
                    <v-img
                      contain
                      height="3vh"
                      src="@/assets/icons/exit.svg"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="'Logout'"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>Logout</span>
            </v-tooltip>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>
    <v-main>
      <slot />
    </v-main>
  </div>
</template>

<script>
import store from "@/store";
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import { NOTIFICATIONS_REFRESH_EVENT } from "@/shared/notificationEvents";
export default {
  name: "PitchEnglishHomeApplicationTemplate",

  data() {
    return {
      drawer: true,
      module: `/connect/${store.getters.module}`,
      mini: false,
      notificationsRefreshTimeout: null,
      refreshingNotifications: false,
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters.user || {};
    },
    avatarUrl() {
      return (
        this.currentUser.avatar ||
        this.currentUser.profilePicture ||
        this.$store.state.avatar ||
        null
      );
    },
    customerInitials() {
      const storedInitials = localStorage.getItem("initials");

      if (storedInitials) {
        return storedInitials;
      }

      const name = this.currentUser.name || this.currentUser.full_name || "";

      return String(name)
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
    },
    notificationsCount() {
      return this.$store.getters.notificationsCount;
    },
    avatarFallbackColor() {
      return this.$store.getters.module === "professor"
        ? "secondary-500"
        : "primary-500";
    },
    // Aluno solo (preference ALONE = 1) nao passa por turmas/match: escondemos
    // o grupo "Turmas" do menu para esse perfil.
    isSoloCustomer() {
      const user = this.$store.getters.user;
      return this.$store.getters.module === "aluno" && user?.preference === 1;
    },
  },

  mounted() {
    this.refreshNotificationsCount();
    window.addEventListener(
      NOTIFICATIONS_REFRESH_EVENT,
      this.scheduleNotificationsRefresh
    );
  },

  beforeDestroy() {
    window.removeEventListener(
      NOTIFICATIONS_REFRESH_EVENT,
      this.scheduleNotificationsRefresh
    );

    if (this.notificationsRefreshTimeout) {
      window.clearTimeout(this.notificationsRefreshTimeout);
    }
  },

  methods: {
    scheduleNotificationsRefresh() {
      if (this.notificationsRefreshTimeout) {
        window.clearTimeout(this.notificationsRefreshTimeout);
      }

      this.notificationsRefreshTimeout = window.setTimeout(() => {
        this.refreshNotificationsCount();
      }, 250);
    },
    async refreshNotificationsCount() {
      if (this.refreshingNotifications || !this.$store.getters.token) {
        return;
      }

      const currentModule = this.$store.getters.module;

      if (!currentModule) {
        return;
      }

      this.refreshingNotifications = true;

      try {
        const api =
          currentModule === "professor" ? pitchPartnerApi : pitchCustomerApi;
        const res = await api.getUnreadNotificationsCount();
        this.$store.dispatch("setNotificationsCount", res.data?.count || 0);
      } catch (_error) {
        return null;
      } finally {
        this.refreshingNotifications = false;
      }
    },
    logoff() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("module");
      this.$router.push({
        path: "/connect",
      });
    },
  },
};
</script>

<style scoped>
.sidebar-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-main {
  flex: 1 1 auto;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 0.75rem;
}

.sidebar-drawer::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-menu-list {
  width: 100%;
}

.sidebar-group {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item__content {
  flex: 1 1 auto;
  min-width: 0;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item__icon:last-child {
  margin-left: auto;
  padding-right: 8px;
}

.notification-badge--active::v-deep .v-badge__badge {
  animation: notificationBadgeBlink 1.2s ease-in-out infinite;
}

.notification-bell--blinking {
  animation: notificationBellBlink 1.2s ease-in-out infinite;
  transform-origin: center;
}

.sidebar-profile-avatar {
  overflow: hidden;
  flex-shrink: 0;
  background: transparent;
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
}

.sidebar-profile-avatar__image {
  width: 100%;
  height: 100%;
}

.sidebar-profile-avatar__image::v-deep .v-image__image,
.sidebar-profile-avatar__image::v-deep .v-image__placeholder {
  background-size: cover !important;
  background-position: center center !important;
}

@keyframes notificationBellBlink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.35;
    transform: scale(1.08);
  }
}

@keyframes notificationBadgeBlink {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.12);
  }
}
</style>
